import Option from '@/modules/common/models/option/option.ts';

export default class TextOption extends Option {
  constructor(response: any) {
    super(response, 'Значение', 'Текст');
  }
}
